import { constants_proveedores } from '../constants/proveedores.constants';

export const obtenerProveedores = () => ({
    type: constants_proveedores.OBTENER_PROVEEDORES_REQUEST,
    payload: {},
});
export const obtenerProveedoresOpto11 = () => ({
    type: constants_proveedores.OBTENER_PROVEEDORES_OPTO11_REQUEST,
    payload: {},
});
